/**
 * Events related to game management
 */
export const events = {
  GAME_STARTED: 'game/started',
  GAME_PAUSED: 'game/paused',
  GAME_ENDED: 'game/ended',
  GOAL_SCORED: 'game/goal-scored',
  GOAL_REMOVED: 'game/goal-removed',
  GAME_RESET: 'game/reset'
};